import { useCurrentUser } from "#/components/context/user/UserContext"
import { useTextDirection } from "#/services/locale/hooks/useTextDirection"
import { TextDirection } from "#/types/Locale"
import { Snackbar } from "@carrotfertility/carotene-core"
import React from "react"
import { useIntl } from "react-intl"

export function NotAllowedWhilePosing(): JSX.Element {
  const { isPosingAsMember } = useCurrentUser()
  const textDirection = useTextDirection()
  const intl = useIntl()
  return isPosingAsMember ? (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: textDirection === TextDirection.RightToLeft ? "right" : "left"
      }}
      open={isPosingAsMember}
      message={intl.formatMessage({
        defaultMessage: "Editing insurance information while posing as a member is not allowed."
      })}
    />
  ) : null
}
